import { View } from "@-/com.npmjs.react-native";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { USER_CARD_STAGE_LABEL } from "@-/dev.improve.haniverse.constants.user-card-stage";
import { PROGRESS_STAGE_BACKGROUND, PROGRESS_STAGE_KEYS } from "#progress-stage-palette";

export function ProgressStageLegend() {
  return (
    <View className="flex-row flex-wrap gap-x-4 gap-y-2">
      {PROGRESS_STAGE_KEYS.map((stage) => (
        <View className="flex-row items-center gap-1.5" key={stage}>
          <View className={`size-2 rounded-full ${PROGRESS_STAGE_BACKGROUND[stage]}`} />
          <Text className="text-xs text-muted-foreground">{USER_CARD_STAGE_LABEL[stage]}</Text>
        </View>
      ))}
    </View>
  );
}
